import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {AuthenticationService, UserDetailService} from "@services";
import {JwtResponse, UserDetail} from "@model";

export const CurrentUserDetailsResolver: ResolveFn<Observable<UserDetail | undefined> |
  Promise<UserDetail | undefined> | UserDetail | undefined> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   userDetailService: UserDetailService = inject(UserDetailService),
   authenticationService: AuthenticationService = inject(AuthenticationService)): Observable<UserDetail | undefined> |
    Promise<UserDetail | undefined> | UserDetail | undefined => {
    let jwtResponse: JwtResponse | null = authenticationService.jwtResponse.value;
    let loggedIn:boolean = !!jwtResponse?.token;
    if (loggedIn) {
      return userDetailService.fetchCurrentUserDetails();
    } else {
      return undefined;
    }
  }
